export enum SelectionTypes {
  Diagram = 'diagram',
  Activity = 'activity',
  Text = 'text',
  Sticker = 'sticker',
  Flowline = 'flowline',
  Image = 'image',
  Connector = 'connector',
  Terminator = 'terminator',
  TextFormatting = 'text-formatting'
}
